import { isUrl } from "utils/utils";

const menuData = [
	{
		name: "Campaigns",
		icon: "dashboard",
		path: "campaigns"
		// children: [{
		//   name: 'Analysis',
		//   path: 'analysis',
		// }, {
		//   name: 'Monitoring',
		//   path: 'monitor',
		// }, {
		//   name: 'Bench',
		//   path: 'workplace',
		//   // hideInMenu: true,
		// }],
	},
	{
		name: "Content",
		icon: "hdd",
		path: "content-groups"
	},
	{
		name: "Blurbs",
		icon: "book",
		path: "old/blurbs"
	},	
	{
		name: "Diagrams",
		icon: "cluster",
		path: "strategies"
	},
	{
		name: "Email Manager",
		icon: "mail",
		path: "email-manager"
	},
	// {
	// 	name: "Cloud Accounts",
	// 	icon: "cloud",
	// 	path: "cloud-accounts"
	// },	
	{
		name: "Custom Sites",
		icon: "dash",
		path: "old/custom_sites"
	},	
	{
		name: "Private Network",
		icon: "deployment-unit",
		path: "private-networks"
	},
	{
		name: "X-Wizard",
		icon: "thunderbolt",
		path: "xwizards"
	},
	{
		name: "Wizard",
		icon: "thunderbolt",
		path: "old/wizards"
	},
	{
		name: "Turbo Wizard",
		icon: "thunderbolt",
		path: "old/turbo_wizards"
	},
	{
		name: "Site Selection",
		icon: "ordered-list",
		// path: "old/site_selections"
		path: "site-selections"
	},
	{
		name: "Settings",
		icon: "setting",
		path: "options",
		target: "_blank"
	},
	{
		name: "Changelog",
		icon: "book",
		path: "http://rankerx.com/rankerx_guides/post/change_log/",
		target: "_blank"
	}
	// {
	// 	name: "Form",
	// 	icon: "form",
	// 	path: "form",
	// 	children: [
	// 		{
	// 			name: "Basic Form",
	// 			path: "basic-form"
	// 		},
	// 		{
	// 			name: "Step-by-Step Form",
	// 			path: "step-form"
	// 		},
	// 		{
	// 			name: "Advanced Form",
	// 			authority: "admin",
	// 			path: "advanced-form"
	// 		}
	// 	]
	// },
	// {
	// 	name: "List",
	// 	icon: "table",
	// 	path: "list",
	// 	children: [
	// 		{
	// 			name: "Inquiry Form",
	// 			path: "table-list"
	// 		},
	// 		{
	// 			name: "Standard List",
	// 			path: "basic-list"
	// 		},
	// 		{
	// 			name: "Card List",
	// 			path: "card-list"
	// 		},
	// 		{
	// 			name: "Search List",
	// 			path: "search",
	// 			children: [
	// 				{
	// 					name: "Search List (Article)",
	// 					path: "articles"
	// 				},
	// 				{
	// 					name: "Search List (Item)",
	// 					path: "projects"
	// 				},
	// 				{
	// 					name: "Search List (Application)",
	// 					path: "applications"
	// 				}
	// 			]
	// 		}
	// 	]
	// },
	// {
	// 	name: "Details Page",
	// 	icon: "profile",
	// 	path: "profile",
	// 	children: [
	// 		{
	// 			name: "Basic Details Page",
	// 			path: "basic"
	// 		},
	// 		{
	// 			name: "Advanced Details Page",
	// 			path: "advanced",
	// 			authority: "admin"
	// 		}
	// 	]
	// },
	// {
	// 	name: "Result Page",
	// 	icon: "check-circle-o",
	// 	path: "result",
	// 	children: [
	// 		{
	// 			name: "Success",
	// 			path: "success"
	// 		},
	// 		{
	// 			name: "Failure",
	// 			path: "fail"
	// 		}
	// 	]
	// },
	// {
	// 	name: "Error Page",
	// 	icon: "warning",
	// 	path: "exception",
	// 	children: [
	// 		{
	// 			name: "403",
	// 			path: "403"
	// 		},
	// 		{
	// 			name: "404",
	// 			path: "404"
	// 		},
	// 		{
	// 			name: "500",
	// 			path: "500"
	// 		},
	// 		{
	// 			name: "Trigger an exception",
	// 			path: "trigger",
	// 			hideInMenu: true
	// 		}
	// 	]
	// },
	// {
	// 	name: "账户",
	// 	icon: "user",
	// 	path: "user",
	// 	authority: "guest",
	// 	children: [
	// 		{
	// 			name: "Login",
	// 			path: "login"
	// 		},
	// 		{
	// 			name: "Register",
	// 			path: "register"
	// 		},
	// 		{
	// 			name: "Registration Result",
	// 			path: "register-result"
	// 		}
	// 	]
	// }
];

function formatter(data, parentPath = "/", parentAuthority) {
	return data.map(item => {
		let { path } = item;
		if (!isUrl(path)) {
			path = parentPath + item.path;
		}
		const result = {
			...item,
			path,
			authority: item.authority || parentAuthority
		};
		if (item.children) {
			result.children = formatter(
				item.children,
				`${parentPath}${item.path}/`,
				item.authority
			);
		}
		return result;
	});
}

export const getMenuData = () => formatter(menuData);
